import { useHistory } from 'react-router-dom';

import analytics from '../../../lib/analytics';

// Shared by pricing-tiers.tsx and hero.tsx. 'contact' ctas open the same ChiliPiper "Contact
// Sales" scheduling dialog used on the Product Catalog list page (see onContactClick, wired up in
// containers/product-catalog/product-detail.tsx). 'buy' ctas with an offerFlow set navigate
// there, landing on that offer's bare URL the same way every other offer entry point works;
// single-plan offers with Pages.OrderReview then auto-advance straight to their Order Review page
// (see OfferPlanSelect's single-plan auto-advance + OfferContainer's routing). 'trial' ctas are
// tracked but not yet wired to a real flow.
type CtaLike = {
  ctaAction: 'trial' | 'buy' | 'contact';
  offerFlow?: string;
};

export const trackCtaClick = (id: string) => analytics.track(`Product detail pricing CTA clicked: ${id}`);

export const usePricingCtaClick = (onContactClick: () => void) => {
  const history = useHistory();

  return (id: string, cta: CtaLike) => {
    trackCtaClick(id);
    if (cta.ctaAction === 'buy' && cta.offerFlow) history.push(`/${cta.offerFlow}`);
    if (cta.ctaAction === 'contact') onContactClick();
  };
};
